import moment from 'moment';

import { Http } from '../../../support';

const from = moment().subtract(1, 'month').format('YYYY-MM-DD');
const to = moment().format('YYYY-MM-DD');

export const initialState = {
  busy: false,
  data: [],
  selectedTab: 'todo',
  filters: {
    page: 1,
    search: '',
  },
  selectedRows: [],
  selectedRowKeys: [],
  result: undefined,
  error: undefined,
  pagination: {
    limit: 25,
    from,
    to,
  },
};

const setSelectedRows = (store, data) => {
  store.setState((state) => {
    state.modulo.timbrado_masivo.tickets = {
      ...state.modulo.timbrado_masivo.tickets,
      ...data,
    };
  });
};

const change = (store, data) => {
  store.setState((state) => {
    state.modulo.timbrado_masivo.tickets.data = {
      ...state.modulo.timbrado_masivo.tickets.data,
      ...data,
    };
  });
};

const paginate = async (store, params) => {
  store.setState((state) => {
    state.modulo.timbrado_masivo.tickets = {
      ...state.modulo.timbrado_masivo.tickets,
      result: undefined,
      error: undefined,
      busy: true,
      filters: {
        ...state.filters,
        ...params,
      },
      pagination: {
        ...state.modulo.timbrado_masivo.tickets.pagination,
        ...params,
      },
    };
  });

  try {
    const { pagination } = store.state.modulo.timbrado_masivo.tickets;

    const body = {
      ...pagination,
      ...params,
      // ...newState.filters,
      //   ...params,
      include: 'conceptos',
    };

    const response = await Http.get(`/api/timbrado-masivo/comprobantes/tickets`, { params: body });

    store.setState((state) => {
      state.modulo.timbrado_masivo.tickets = {
        ...state.modulo.timbrado_masivo.tickets,
        busy: false,
        data: response.data,
        pagination: {
          ...state.modulo.timbrado_masivo.tickets.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.timbrado_masivo.tickets.busy = false;
      state.modulo.timbrado_masivo.tickets.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.modulo.timbrado_masivo.tickets = {
      ...initialState,
    };
  });
};

const TimbradoMasivoTicketListStore = {
  state: () => initialState,
  actions: {
    change,
    setSelectedRows,
    paginate,
    reset,
  },
};

export default TimbradoMasivoTicketListStore;
